// TODO
import React from 'react'
import { Grid2, styled } from '@mui/material'
import { mainColor, veryLightColor } from './theme'

export const LightCard = styled(({ sx, ...other }) => (<Grid2 sx={{ padding: '24px', borderRadius: '20px', backgroundColor: veryLightColor, color: mainColor, ...sx }} {...other} />))({})
